<mat-progress-spinner [value]="value"> </mat-progress-spinner>
<h1>{{ value }}%</h1>
